module.exports = require("@jupiter/plugin-runtime/i18n");